import { unmarshaller as commonCfg } from './common-config-header-footer-video';

// Here this config will be merge with the default video config
export const unmarshaller = {
  ...commonCfg
};
